module.exports = __webpack_public_path__ + "media/img/uploads/atak-mil-product-full-03-8fdbfe80ae4072022947c840f8f496d9.jpg";